import { USERNAME_MAX, USERNAME_PATTERN } from '../schemas/client';

/**
 * What the owner form refuses, kept out of the component so it can be read and
 * tested without rendering anything.
 *
 * Both return `undefined` for an empty field: empty is unfinished, not wrong,
 * and whether a field is required is the submit button's question. Only a value
 * that has been typed and cannot work gets an answer.
 *
 * This was `wizard-state.ts`, which also held the new-client wizard's draft,
 * step completion and failure taxonomy. That wizard is DELETED, not parked —
 * see `NewClientComingSoon` for why and for how to get it back — and the rest
 * went with it rather than staying as exports nothing calls. These two are what
 * `ProvisionOwnerPage` still uses.
 */

export function usernameError(username: string): string | undefined {
    if (username.length === 0) return undefined;
    if (username.length > USERNAME_MAX) {
        return `At most ${String(USERNAME_MAX)} characters — that is Cognito’s limit, not ours.`;
    }
    return USERNAME_PATTERN.test(username) ? undefined : 'No spaces or control characters.';
}

export function emailError(email: string): string | undefined {
    if (email.length === 0) return undefined;
    return /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)
        ? undefined
        : 'That email is not a valid address.';
}
